import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import PaymentReportHeaderListing from '../../modules/admin/components/PaymentReportHeaderListing';

const PaymentReport = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>PaymentReport.PaymentReport')} />

      <PaymentReportHeaderListing />
    </>
  );
};

export default PaymentReport;
